import React, {useEffect, useState} from "react";
import './IndividualQuoter.css'
import imgQualitas from "@images/qualitas.svg";
import imgAfirme from "@images/afirme.svg";
import imgMapfre from "@images/mapfre.svg";
import imgChubb from "@images/chubb.svg";
import imgGnp from "@images/gnp.svg";
import imgHdi from "@images/hdi.svg"
import {Form, Formik} from 'formik';
import {
    getClientByEmail,
    getMark,
    getVersion,
    postQuotation,
    postServiceInsurance
} from "../../services/cotizador-service";
import Swal from "sweetalert2";
import $ from 'jquery';
import {v4 as uuidv4} from 'uuid';
import {getTokenGeneric, getUserConfiguration, handleLogout} from "../../services/auth-service";
import {getPaymentMethods} from "../../services/collection-service";
import InsuranceCard from "../../components/Quoters/Card/InsuranceCard";
import {VehicleDataCaptureCard} from "../../components/Quoters/Card/VehicleDataCaptureCard";
import {CoveragesCard} from "../../components/Quoters/Card/CoveragesCard";
import {getCoberturasByPackage, getCoberturasByPlan} from "../../services/coverages-service";
import {Cookies} from "react-cookie";
import {enableBanjercito} from "../../index";
import Navbar from "../../components/Navbar/Navbar";

export default function IndividualQuoter(props) {

    //Activate/Desactivate loading animation.
    const [loadingQualitas, setLoadingQualitas] = useState(false);
    const [loadingAfirme, setLoadingAfirme] = useState(false);
    const [loadingMapfre, setLoadingMapfre] = useState(false);
    const [loadingGnp, setLoadingGnp] = useState(false);
    const [loadingChubb, setLoadingChubb] = useState(false);
    const [loadingHdi, setLoadingHdi] = useState(false);

    //Activate/Desactivate totalPrime of quotation.
    const [showCostoQualitas, setShowCostoQualitas] = useState(false);
    const [showCostoAfirme, setShowCostoAfirme] = useState(false);
    const [showCostoMapfre, setShowCostoMapfre] = useState(false);
    const [showCostoGnp, setShowCostoGnp] = useState(false);
    const [showCostoChubb, setShowCostoChubb] = useState(false);
    const [showCostoHdi, setShowCostoHdi] = useState(false);

    const [showErrorQualitas, setShowErrorQualitas] = useState(false);
    const [showErrorAfirme, setShowErrorAfirme] = useState(false);
    const [showErrorMapfre, setShowErrorMapfre] = useState(false);
    const [showErrorGnp, setShowErrorGnp] = useState(false);
    const [showErrorChubb, setShowErrorChubb] = useState(false);
    const [showErrorHdi, setShowErrorHdi] = useState(false);

    const [showErrorMessageQualitas, setShowErrorMessageQualitas] = useState('');
    const [showErrorMessageAfirme, setShowErrorMessageAfirme] = useState('');
    const [showErrorMessageMapfre, setShowErrorMessageMapfre] = useState('');
    const [showErrorMessageGnp, setShowErrorMessageGnp] = useState('');
    const [showErrorMessageChubb, setShowErrorMessageChubb] = useState('');
    const [showErrorMessageHdi, setShowErrorMessageHdi] = useState('');

    //Select of mark & version.
    const [carMark, setCarMark] = useState([]);
    const [carVersion, setCarVersion] = useState([]);

    const [insuranceQualitas, setInsuranceQualitas] = useState([]);
    const [insuranceAfirme, setInsuranceAfirme] = useState([]);
    const [insuranceMapfre, setInsuranceMapfre] = useState([]);
    const [insuranceGnp, setInsuranceGnp] = useState([]);
    const [insuranceChubb, setInsuranceChubb] = useState([]);
    const [insuranceHdi, setInsuranceHdi] = useState([]);

    let quoteJsonQualitas = {};
    let quoteJsonAfirme = {};
    let quoteJsonMapfre = {};
    let quoteJsonGnp = {};
    let quoteJsonChubb = {};
    let quoteJsonHdi = {};

    //MovementId to emit.
    let [movementIdQualitas, setMovementIdQualitas] = useState('');
    let [movementIdAfirme, setMovementIdAfirme] = useState('');
    let [movementIdMapfre, setMovementIdMapfre] = useState('');
    let [movementIdGnp, setMovementIdGnp] = useState('');
    let [movementIdChubb, setMovementIdChubb] = useState('');
    let [movementIdHdi, setMovementIdHdi] = useState('');

    let [quoteNumberQualitas, setQuoteNumberQualitas] = useState('');
    let [quoteNumberAfirme, setQuoteNumberAfirme] = useState('');
    let [quoteNumberMapfre, setQuoteNumberMapfre] = useState('');
    let [quoteNumberGnp, setQuoteNumberGnp] = useState('');
    let [quoteNumberChubb, setQuoteNumberChubb] = useState('');
    let [quoteNumberHdi, setQuoteNumberHdi] = useState('');

    let [receiptInfo_cost_qualitas, setReceiptInfo_cost_qualitas] = useState('');
    let [receiptInfo_cost_afirme, setReceiptInfo_cost_afirme] = useState('');
    let [receiptInfo_cost_mapfre, setReceiptInfo_cost_mapfre] = useState('');
    let [receiptInfo_cost_gnp, setReceiptInfo_cost_gnp] = useState('');
    let [receiptInfo_cost_chubb, setReceiptInfo_cost_chubb] = useState('');
    let [receiptInfo_cost_Hdi, setReceiptInfo_cost_Hdi] = useState('');

    let [paymentMethods, setPaymentMethods] = useState([]);

    {/*
    const [showModalQualitas, setShowModalQualitas] = useState(false);
    const toggleModalQualitas = () => {
        setShowModalQualitas(!showModalQualitas);
    };
    const [coveragesQualitas, setCoveragesQualitas] = useState([]);
    const getCoveragesQualitasObject = (data) => {
        setCoveragesQualitas(data);
    }
    const [showModalAfirme, setShowModalAfirme] = useState(false);
    const toggleModalAfirme = () => {
        setShowModalAfirme(!showModalAfirme);
    };
    const [coveragesAfirme, setCoveragesAfirme] = useState([]);
    //Get back data from component child.
    const getCoveragesAfirmeObject = (data) => {
        setCoveragesAfirme(data);
    }
    const [showModalMapfre, setShowModalMapfre] = useState(false);
    const toggleModalMapfre = () => {
        setShowModalMapfre(!showModalMapfre);
    };
    const [coveragesMapfre, setCoveragesMapfre] = useState([]);
    const getCoveragesMapfreObject = (data) => {
        setCoveragesMapfre(data);
    }
    */
    }

    //SpecialAdaptations
    const [specialAdaptations, setSpecialAdaptations] = useState([]);
    const getSpecialAdaptationsObject = (data) => {
        setSpecialAdaptations(data);
    }

    //Coverages
    let [coveragesQualitas, setCoveragesQualitas] = useState([]);
    let [coveragesAfirme, setCoveragesAfirme] = useState([]);
    let [coveragesMapfre, setCoveragesMapfre] = useState([]);
    let [coveragesGnp, setCoveragesGnp] = useState([]);
    let [coveragesChubb, setCoveragesChubb] = useState([]);
    let [coveragesHdi, setCoverageHdi] = useState([]);

    let [coveragesPackage, setCoveragesPackage] = useState([]);
    let [showCoverages, setShowCoverages] = useState(false);
    let [showLoadingCoverages, setShowLoadingCoverages] = useState(false);

    //Cofig to UdiFlag
    let [isAdaptableUdi, setIsAdaptableUdi] = useState();

    //Kerno user configs
    const [insuranceCompanies, setInsuranceCompanies] = useState([]);
    const [planTypes, setPlanTypes] = useState([]);
    const [isAbleToQuote, setIsAbleToQuote] = useState([]);
    const [specialAdaptationsFlag, setSpecialAdaptationsFlag] = useState([]);

    //Auxiliar Methods
    const clearLoading = () => {
        setLoadingQualitas(false);
        setLoadingAfirme(false);
        setLoadingMapfre(false);
        setLoadingGnp(false);
        setLoadingChubb(false);
        setLoadingHdi(false);
    }
    const clearCost = () => {
        setShowCostoQualitas(false);
        setShowCostoAfirme(false);
        setShowCostoMapfre(false);
        setShowCostoGnp(false);
        setShowCostoChubb(false);
        setShowCostoHdi(false);
    }
    const clearErrorMessage = () => {
        setShowErrorQualitas(false);
        setShowErrorAfirme(false);
        setShowErrorMapfre(false);
        setShowErrorGnp(false);
        setShowErrorChubb(false);
        setShowErrorHdi(false);
    }
    const clearInsuranceSelect = (values) => {
        clearLoading();
        insuranceQualitas.length = 0;
        insuranceAfirme.length = 0;
        insuranceMapfre.length = 0;
        insuranceGnp.length = 0;
        insuranceChubb.length = 0;
        insuranceHdi.length = 0;
        values.qualitas = "Seleccionar...";
        values.afirme = "Seleccionar...";
        values.mapfre = "Seleccionar...";
        values.gnp = "Seleccionar...";
        values.chubb = "Seleccionar...";
        values.hdi = "Seleccionar...";
    }
    const setLoadingAnimation = () => {
        if(insuranceQualitas.length >= 1)
        setLoadingQualitas(true);
        if(insuranceAfirme.length >= 1)
        setLoadingAfirme(true);
        if(insuranceMapfre.length >= 1)
        setLoadingMapfre(true);
        if(insuranceGnp.length >= 1)
        setLoadingGnp(true);
        if(insuranceChubb.length >= 1)
        setLoadingChubb(true);
        if(insuranceHdi.length >= 1)
        setLoadingHdi(true)
    }
    const loadHomologatedCoverages = () => {
        setShowLoadingCoverages(false);
        return setShowCoverages(true);
    }
    const clearAllInputs = (values) => {
        clearLoading();
        values.bill_value = "";
        values.mark = "";
        values.version = "";
        values.model_year = "";
        values.antiquity = null;
        clearInsuranceSelect(values);
        carMark.length = 0;
        carVersion.length = 0;
        clearCost();
        clearErrorMessage();
    }
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    const obtainMarks = (e, values) => {
        //Clearing Selects
        values.mark = "";
        values.version = "";
        values.antiquity = null;
        clearInsuranceSelect(values);
        return getMark(e.target.value,values.type, values.use).then(data => {
            carMark.length = 0;
            carVersion.length = 0;
            clearCost();
            clearErrorMessage();
            if (data) setCarMark(data);
        });
    }
    const obtainVersion = (e, values) => {
        //Clearing Selects
        values.version = "";
        clearInsuranceSelect(values);
        return getVersion(values.model_year, e.target.value,values.type, values.use).then(data => {
            carVersion.length = 0;
            clearCost();
            clearErrorMessage();
            let auxVersionAutos = [];
            for (let i in data) auxVersionAutos.push(data[i].cTipo + ' ' + data[i].cVersion);
            setCarVersion(auxVersionAutos);
        });
    }
    const obtainResponseFromInsuranceCompany = (e, values) => {
        return postServiceInsurance(values.model_year, values.mark, e.target.value, values.type, values.use).then(data => {
            console.log(data)
            clearInsuranceSelect(values);
            clearCost();
            clearErrorMessage();
            let auxQualitas;
            let auxAfirme;
            let auxMapfre;
            let auxGnp;
            let auxChubb;
            let auxHdi;
            if(insuranceCompanies.find(company => company.id === 1)) { //Qualitas
                auxQualitas = data.filter(getData => getData.insuranceCompanyId.includes('1'));
                //for (let i in auxQualitas) setInsuranceQualitas(auxQualitas);
                setInsuranceQualitas(auxQualitas)
                if (!auxQualitas.length) {
                    setShowErrorQualitas(true);
                    setShowErrorMessageQualitas('No se encontraron elementos con Quálitas');
                }
            }
            if(insuranceCompanies.find(company => company.id === 6)) { //Afirme, El valor 6 se trata porque es el 6to registro de la tabla quote
                auxAfirme = data.filter(getData => getData.insuranceCompanyId.includes('2'));
                for (let i in auxAfirme) setInsuranceAfirme(auxAfirme);
                if (!auxAfirme.length) {
                    setShowErrorAfirme(true);
                    setShowErrorMessageAfirme('No se encontraron elementos con Afirme');
                }
            }
            if(insuranceCompanies.find(company => company.id === 5)) { //Mapfre
                    auxMapfre = data.filter(getData => getData.insuranceCompanyId.includes('3'));
                    for (let i in auxMapfre) {setInsuranceMapfre(auxMapfre)}
                    if(!auxMapfre.length) {
                        setShowErrorMapfre(true);
                        setShowErrorMessageMapfre('No se encontraron elementos con Mapfre');
                    }
            }
            if(insuranceCompanies.find(company => company.id === 7)) { //GNP
                auxGnp = data.filter(getData => getData.insuranceCompanyId.includes('7'));
                for (let i in auxGnp) setInsuranceGnp(auxGnp);
                if (!auxGnp.length) {
                    setShowErrorGnp(true);
                    setShowErrorMessageGnp('No se encontraron elementos con GNP');
                }
            }
            if(insuranceCompanies.find(company => company.id === 2)) { //CHUBB
                auxChubb = data.filter(getData => getData.insuranceCompanyId.includes('4'));
                for (let i in auxChubb) setInsuranceChubb(auxChubb);
                if (!auxChubb.length) {
                    setShowErrorChubb(true);
                    setShowErrorMessageChubb('No se encontraron elementos con Chubb');
                }
            } //Hdi -----------------> aquí se pone los elementos del homologador
            if(insuranceCompanies.find(company => company.id === 8 )){
                auxHdi = data.filter(getData => getData.insuranceCompanyId.includes('5'))
                setInsuranceHdi(auxHdi)
                if(!auxHdi.length){
                    setShowErrorHdi(true)
                    setShowErrorMessageHdi("No se encontraron elementos en Hdi")
                }
            }
        });
    }
    const obtainCoveragesFromPackage = (e) => {
        //Qualitas 1
        return getCoberturasByPackage(23011, 1, e.target.value).then(data => {
            setShowLoadingCoverages(true);
            setShowCoverages(false);
            getCoberturasByPlan(data.plan).then(coverages => {
                return setCoveragesPackage(Object.assign(coverages.filter(getHomologated => getHomologated.displayHomologated === true)));
            }).then(() => //Afirme 6
                getCoberturasByPackage(23011, 2, e.target.value).then(data => {
                    return getCoberturasByPlan(data.plan).then(coverages => {
                        return setCoveragesPackage(Object.assign(coverages.filter(getHomologated => getHomologated.displayHomologated === true)));
                    });
                })).then(() => //Mapfre 5
                getCoberturasByPackage(23011, 3, e.target.value).then(data => {
                    return getCoberturasByPlan(data.plan).then(coverages => {
                        return setCoveragesPackage(Object.assign(coverages.filter(getHomologated => getHomologated.displayHomologated === true)));
                    });
                })).then(() => //Chubb 2
                getCoberturasByPackage(23011, 4, e.target.value).then(data => {
                    return getCoberturasByPlan(data.plan).then(coverages => {
                        return setCoveragesPackage(Object.assign(coverages.filter(getHomologated => getHomologated.displayHomologated === true)));
                    });
                })).then(() => //GNP 7
                getCoberturasByPackage(23011, 7, e.target.value).then(data => {
                    return getCoberturasByPlan(data.plan).then(coverages => {
                        return setCoveragesPackage(Object.assign(coverages.filter(getHomologated => getHomologated.displayHomologated === true)));
                    });
                })).then(() => //HDI SEGUROS
                getCoberturasByPackage(23011, 5, e.taget.value).then(data => {
                    return getCoberturasByPlan(data.plan).then(coverages => {
                        return setCoveragesPackage(Object.assign(coverages.filter(getHomologated => getHomologated.displayHomologated === true)));
                    })
                })
            )
        }).then(setTimeout(loadHomologatedCoverages, 1500))


    }

    const quotate = (values) => {
        console.log(values)
        //Clears the inputs of the form if the user wants to requote.
        clearCost();
        clearLoading();
        //clearErrorMessage();
        //Gets the vehicleData with the rank of the selected input (1,2 or 3)
        let auxVehicleDataQualitas = insuranceQualitas[$('#rank_qualitas option:selected').prevAll().length];
        let auxVehicleDataAfirme = insuranceAfirme[$('#rank_afirme option:selected').prevAll().length];
        let auxVehicleDataMapfre = insuranceMapfre[$('#rank_mapfre option:selected').prevAll().length];
        let auxVehicleDataGnp = insuranceGnp[$('#rank_gnp option:selected').prevAll().length];
        let auxVehicleDataChubb = insuranceChubb[$('#rank_chubb option:selected').prevAll().length];
        let auxVehicleDataHdi = insuranceHdi[$('#rank_hdi option:selected').prevAll().length];
        //bill_value set to 0.
        if (values.bill_value == '') {
            values.bill_value = '00';
        }
        let type = null;
        let use = null;
        if (values.type === '1' && values.use === '1') {  type = '0'; use = '1';}
        if (values.type === '2' && values.use === '1') { type = '1'; use = '5';}
        if (values.coverage_plan === '2') {
            values.material_damages = null;
            values.total_thefts = null;
        }
        if (values.coverage_plan === '3') {
            values.material_damages = null;
        }

        //Setting JSONS for quotations requests
        let uuid = uuidv4();
        if(insuranceCompanies.find(company => company.id === 1)) //Qualitas
        quoteJsonQualitas = {
            insuranceCompanyId: '1', // Id de la aseguradora
            quoteTypeId: '1', // tipo de cotizacion en este caso es 1=Prospecto
            circulationZipCode: values.cp, //CódigoPostal
            vehicleData: auxVehicleDataQualitas, // El Json del vehiculo seleccionado en el select de la aseguradora
            modelYear: values.model_year, // Año modelo
            invoiceValue: values.bill_value, // monto de valor factura
            vehicleTypeId: type, // tipo de Vehiculo
            useId: use, // Tpo de uso del vehiculo
            loadTypeId: '', // tipo de carga (mandar nulo)
            serviceId: '', // tipo de servicio (mandar nulo)
            term: '12', //Plazo en meses mandar si es nulo se cotiza a 12 meses
            uuid: uuid,// Generar un UUID y ese se envia a todas las aseguradoras por cada click en cotizar
            wayToPayId: parseInt(values.payment),
            adaptionsSpecial: specialAdaptations, //Objeto de adaptaciones especiales
            packageId: parseInt(values.coverage_plan), //Id del paquete
            deductiblePercentageDM: parseInt(values.material_damages) || null,
            deductiblePercentageRT: parseInt(values.total_thefts) || null,
            email: values.email || null, //email for public users
            phone: values.phone || null, // phone for public users
            udiId:values.udi //---> Valor del Udi
        };
        if(insuranceCompanies.find(company => company.id === 6)) //Afirme
        quoteJsonAfirme = {
            insuranceCompanyId: '2',
            quoteTypeId: '1',
            circulationZipCode: values.cp,
            vehicleData: auxVehicleDataAfirme,
            modelYear: values.modelo_year,
            invoiceValue: values.bill_value,
            vehicleTypeId: type,
            useId: use,
            loadTypeId: '',
            serviceId: '',
            term: '12',
            uuid: uuid,
            wayToPayId: parseInt(values.payment),
            adaptionsSpecial: specialAdaptations,
            packageId: parseInt(values.coverage_plan), //Id del paquete
            deductiblePercentageDM: parseInt(values.material_damages) || null,
            deductiblePercentageRT: parseInt(values.total_thefts) || null,
            email: values.email || null,
            phone: values.phone || null
        };
        if(insuranceCompanies.find(company => company.id === 5)) //Mapfre
        quoteJsonMapfre = {
            insuranceCompanyId: '3',
            quoteTypeId: '1',
            circulationZipCode: values.cp,
            vehicleData: auxVehicleDataMapfre,
            modelYear: values.model_year,
            invoiceValue: values.bill_value,
            vehicleTypeId: type,
            useId: use,
            loadTypeId: '',
            serviceId: '',
            term: '12',
            uuid: uuid,
            wayToPayId: parseInt(values.payment),
            adaptionsSpecial: specialAdaptations,
            packageId: parseInt(values.coverage_plan), //Id del paquete
            deductiblePercentageDM: parseInt(values.material_damages) || null,
            deductiblePercentageRT: parseInt(values.total_thefts) || null,
            email: values.email || null,
            phone: values.phone || null
        };
        if(insuranceCompanies.find(company => company.id === 7)) //GNP
        quoteJsonGnp = {
            insuranceCompanyId: '7',
            quoteTypeId: '1',
            circulationZipCode: values.cp,
            vehicleData: auxVehicleDataGnp,
            modelYear: values.model_year,
            invoiceValue: values.bill_value,
            vehicleTypeId: type,
            useId: use,
            loadTypeId: '',
            serviceId: '',
            term: '12',
            uuid: uuid,
            wayToPayId: parseInt(values.payment),
            adaptionsSpecial: specialAdaptations,
            packageId: parseInt(values.coverage_plan), //Id del paquete
            deductiblePercentageDM: parseInt(values.material_damages) || null,
            deductiblePercentageRT: parseInt(values.total_thefts) || null,
            email: values.email || null,
            phone: values.phone || null
        };
        if(insuranceCompanies.find(company => company.id === 2)) //Chubb
        quoteJsonChubb = {
            insuranceCompanyId: '4',
            quoteTypeId: '1',
            circulationZipCode: values.cp,
            vehicleData: auxVehicleDataChubb,
            modelYear: values.model_year,
            invoiceValue: values.bill_value,
            vehicleTypeId: type,
            useId: use,
            loadTypeId: '',
            serviceId: '',
            term: '12',
            uuid: uuid,
            wayToPayId: parseInt(values.payment),
            adaptionsSpecial: specialAdaptations,
            packageId: parseInt(values.coverage_plan), //Id del paquete
            deductiblePercentageDM: parseInt(values.material_damages) || null,
            deductiblePercentageRT: parseInt(values.total_thefts) || null,
            email: values.email || null,
            phone: values.phone || null
        };
        //HDI cotización
        if(insuranceCompanies.find(company => company.id === 8))
        quoteJsonHdi = {
            insuranceCompanyId: '5',
            quoteTypeId: '1',
            circulationZipCode: values.cp,
            vehicleData: auxVehicleDataHdi,
            modelYear: values.model_year,
            invoiceValue: values.bill_value,
            vehicleTypeId: type,
            useId: use,
            loadTypeId: '',
            serviceId: '',
            term: '12',
            uuid: uuid,
            wayToPayId: parseInt(values.payment),
            adaptionsSpecial: specialAdaptations,
            packageId: parseInt(values.coverage_plan), //Id del paquete
            deductiblePercentageDM: parseInt(values.material_damages) || null,
            deductiblePercentageRT: parseInt(values.total_thefts) || null,
            email: values.email || null,
            phone: values.phone || null
        }
        setLoadingAnimation();
        sendQuotation();
    }
    const sendQuotation = () => {
        if(insuranceCompanies.find(company => company.id === 1) && insuranceQualitas.length >= 1) //Qualitas
        postQuotation(quoteJsonQualitas)
            .then(data => {
                //setLoadingQualitas(true);
                setShowErrorQualitas(false);
                setMovementIdQualitas(data.movementId);
                setQuoteNumberQualitas(data.quoteNumber);
                setCoveragesQualitas(data.coverages);
                setShowCostoQualitas(true);
                return setReceiptInfo_cost_qualitas(data.receiptInfo);
            })
            .then(() => setLoadingQualitas(false))
            .catch(error => {
                setLoadingQualitas(false);
                setShowErrorQualitas(true);
                setShowErrorMessageQualitas(error.response.data)
                if (error.response.status == 401) {
                    Swal.fire({
                        title: 'La sesión expiró',
                        text: 'Accede nuevamente',
                        icon: 'info',
                        iconColor: 'var(--skrSecondary)',
                        backdrop: `rgba(71, 10, 104, .75)`,
                        showCancelButton: true,
                        showConfirmButton: false,
                        cancelButtonColor: '#D0006FFF',
                        cancelButtonText: 'Ok'
                    });
                    return handleLogout();
                }
            })
        if(insuranceCompanies.find(company => company.id === 6) && insuranceAfirme.length >= 1) //Afirme
        postQuotation(quoteJsonAfirme)
            .then(data => {
                //setLoadingAfirme(true);
                setShowErrorAfirme(false);
                setMovementIdAfirme(data.movementId);
                setQuoteNumberAfirme(data.quoteNumber);
                setCoveragesAfirme(data.coverages);
                setShowCostoAfirme(true);
                if (data.receiptInfo != null)
                    return setReceiptInfo_cost_afirme(data.receiptInfo);
            })
            .then(() => setLoadingAfirme(false))
            .catch(error => {
                setLoadingAfirme(false);
                setShowErrorAfirme(true);
                setShowErrorMessageAfirme(error.response.data);
            })
        if(insuranceCompanies.find(company => company.id === 5) && insuranceMapfre.length >= 1) //Mapfre
        postQuotation(quoteJsonMapfre)
            .then(data => {
                //setLoadingMapfre(true);
                setShowErrorMapfre(false);
                setMovementIdMapfre(data.movementId);
                setQuoteNumberMapfre(data.quoteNumber);
                setCoveragesMapfre(data.coverages);
                setShowCostoMapfre(true)
                return setReceiptInfo_cost_mapfre(data.receiptInfo);
            })
            .then(() => setLoadingMapfre(false))
            .catch(error => {
                setLoadingMapfre(false);
                setShowErrorMapfre(true);
                setShowErrorMessageMapfre(error.response.data);
            })
        if(insuranceCompanies.find(company => company.id === 7) && insuranceGnp.length >= 1) //GNP
        postQuotation(quoteJsonGnp)
            .then(data => {
                //setLoadingGnp(true);
                setShowErrorGnp(false);
                setMovementIdGnp(data.movementId);
                setQuoteNumberGnp(data.quoteNumber);
                setCoveragesGnp(data.coverages);
                setShowCostoGnp(true);
                return setReceiptInfo_cost_gnp(data.receiptInfo);
            })
            .then(() => setLoadingGnp(false))
            .catch(error => {
                setLoadingGnp(false);
                setShowErrorGnp(true);
                setShowErrorMessageGnp(error.response.data);
            })
        if(insuranceCompanies.find(company => company.id === 2) && insuranceChubb.length >= 1) //Chubb
        postQuotation(quoteJsonChubb)
            .then(data => {
                //setLoadingChubb(true);
                setShowErrorChubb(false);
                setMovementIdChubb(data.movementId);
                setQuoteNumberChubb(data.quoteNumber);
                setCoveragesChubb(data.coverages);
                setShowCostoChubb(true);
                return setReceiptInfo_cost_chubb(data.receiptInfo);
            })
            .then(() => setLoadingChubb(false))
            .catch(error => {
                setLoadingChubb(false);
                setShowErrorChubb(true);
                setShowErrorMessageChubb(error.response.data);
            });
        if(insuranceCompanies.find(company => company.id === 8) && insuranceHdi.length >= 1) //HDI
            postQuotation(quoteJsonHdi)
            .then(data => {
                //setLoadingChubb(true);
                setShowErrorHdi(false);
                setMovementIdHdi(data.movementId);
                setQuoteNumberHdi(data.quoteNumber);
                setCoverageHdi(data.coverages);
                setShowCostoHdi(true);
                return setReceiptInfo_cost_Hdi(data.receiptInfo);
            })
            .then(() => setLoadingHdi(false))
            .catch(error => {
                setLoadingHdi(false);
                setShowErrorHdi(true);
                setShowErrorMessageHdi(error.response.data);
            });
    }

    const isAuthenticated = localStorage.getItem("isAuthenticated");
    const cookies = new Cookies();
    let poolCustomerId = cookies.get('poolCustomerId');

    useEffect(() => {
            // 27783 = user: default (For ISSFAM default)
            getUserConfiguration(poolCustomerId ?? 27783).then(response => {
                //Integrate Flag to Udi Adaptable
                setInsuranceCompanies(response.insuranceCompanies);
                setPlanTypes(response.planTypes);
                setPaymentMethods(response.wayToPays);
                setSpecialAdaptationsFlag(response.specialAdaptations);
                setIsAbleToQuote(response.available);
                setIsAdaptableUdi(response.adaptableUdi);
                if (response.available === false) {
                    Swal.fire(
                        {
                            icon: 'error',
                            iconColor: 'var(--skrSecondary)',
                            backdrop: `rgba(71, 10, 104, .75)`,
                            text: "La configuración para el negocio no tiene un valor de cotización asignado"
                        });
                }
            }).catch(() => {
                setIsAbleToQuote(false);
                Swal.fire(
                    {
                        icon: 'error',
                        iconColor: 'var(--skrSecondary)',
                        backdrop: `rgba(71, 10, 104, .75)`,
                        text: "La configuración para el negocio no tiene un valor de cotización asignado"
                    });
            });
    }, []);

    return (
        <>
            <div>

                {/*
                {showModalQualitas ?
                    <ModalCoveragesQualitas coverages={coveragesQualitas}
                                            coveragesQualitas={getCoveragesQualitasObject} isOpen={showModalQualitas}
                                            toggle={toggleModalQualitas}/> : null}
                {showModalAfirme ?
                    <ModalCoveragesAfirme coverages={coveragesAfirme} coveragesAfirme={getCoveragesAfirmeObject}
                                          isOpen={showModalAfirme} toggle={toggleModalAfirme}/> : null}
                {showModalMapfre ?
                    <ModalCoveragesMapfre coverages={coveragesMapfre} coveragesMapfre={getCoveragesMapfreObject}
                                          isOpen={showModalMapfre} toggle={toggleModalMapfre}/> : null}
                                          */}


                <Formik initialValues={{
                    type: '1',
                    use: '1',
                    model: '',
                    description: '',
                    qualitas: '',
                    afirme: '',
                    mapfre: '',
                    gnp: '',
                    chubb: '',
                    hdi:'',
                    cp: '',
                    model_year: '',
                    antiquity: '',
                    version: '',
                    bill_value: '',
                    mark: '',
                    payment: '',
                    movementId: '',
                    phone: '',
                    email: '',
                    coverage_plan: '',
                    material_damages: '3',
                    total_thefts: '5',
                    udi:'',
                }} onSubmit={(values,) => {
                            if (!isAuthenticated) { //Searching if client is registered by email or phone
                                return getClientByEmail(values.email).then(data => {
                                    return Swal.fire({
                                        icon: 'question',
                                        titleText: 'Datos del cliente',
                                        allowOutsideClick: false,
                                        backdrop: `rgba(71, 10, 104, .75)`,
                                        html: '<p class="panel list-group text-center">' +
                                            '<div class="list-group-item">' +
                                            '<label>' +
                                            '<strong><u><i class="bi bi-person"></i> Cliente: </u>' +
                                            '</strong>' +
                                            '</label>' +
                                            '<h6 class="mt-1">' + data.name + " " + data.firstSurname + " " + data.lastSurname + '</h6>' +
                                            '</div>' +
                                            '<div class="list-group-item">' +
                                            '<label>' +
                                            '<strong><u><i class="bi bi-house"></i> Código postal: </u>' +
                                            '</strong>' +
                                            '</label>' +
                                            '<h6 class="mt-1">' + data.zipCode + '</h6>' +
                                            '</div>' +
                                            '</p>¿Deseas cotizar con estos datos?</p>' +
                                            '</div>',
                                        confirmButtonText: "Cotizar con estos datos",
                                        cancelButtonText: "Cotizar sin estos datos",
                                        showCancelButton: true,
                                        confirmButtonColor: '#D0006FFF',
                                        cancelButtonColor: '#D0006FFF'
                                    }).then((result) => {
                                        if (result.isConfirmed) { //we quote with customer data
                                            //Replacing data with customer data
                                            return values.cp = data.zipCode;
                                        }
                                    }).then(() => { //we quote with inputs data
                                        return quotate(values);
                                    })
                                }).catch(() => { //If no client we quote normal
                                    return quotate(values);
                                })
                            }
                            //Normal quotation
                            return quotate(values);
                        }}>

                    {({values, handleChange}) => (
                        <Form onChange={handleChange}>
                            <div className="container mt-5">
                                <div className="row justify-content-center">
                                    <VehicleDataCaptureCard
                                        formikValues={values}
                                        userPermissions={props.userPermissions}
                                        handleChange={handleChange}
                                        carMark={carMark}
                                        carVersion={carVersion}
                                        isAuthenticated={isAuthenticated}
                                        getSpecialAdaptationsObject={getSpecialAdaptationsObject}
                                        obtainMarks={obtainMarks}
                                        obtainVersion={obtainVersion}
                                        clearAllInputs={clearAllInputs}
                                        specialAdaptationsFlag={specialAdaptationsFlag}
                                        obtainResponseFromInsuranceCompany={obtainResponseFromInsuranceCompany}/>

                                    {/*
                                        <div className="col-sm-12 col-lg-3 text-center">
                                            <div className="container card-border py-5"
                                                 style={{minHeight: '36rem', marginTop: '2rem'}}>
                                                <h4 className="mb-4 border-bottom montserratMedium">Configuración Banjercito</h4>
                                            <h5>Plan: Amplio</h5>
                                                <h6>Daños materiales: 5%</h6>
                                                <h6>Robo total: 10%</h6>
                                            <h5>Forma de pago: Anual</h5>
                                        </div>
                                        </div> */}
                                    <CoveragesCard
                                        formikValues={values}
                                        handleChange={handleChange}
                                        coveragesPackage={coveragesPackage}
                                        obtainCoveragesFromPackage={obtainCoveragesFromPackage}
                                        showLoadingCoverages={showLoadingCoverages}
                                        showCoverages={showCoverages}
                                        paymentMethods={paymentMethods}
                                        planTypes={planTypes}
                                        adaptableUdi={isAdaptableUdi}
                                    />

                                </div>
                            </div>

                            <div className="container text-center">

                                {insuranceCompanies.find(company => company.id === 1) ? //Configuration of user from Kerno
                                    <InsuranceCard
                                        companyName="qualitas"
                                        companyFormik={values.qualitas}
                                        companyID='1'
                                        cardSize="col-sm-12 col-md-12 col-lg-10"
                                        cardImg={imgQualitas}
                                        imageStyles="mx-4 my-3"
                                        cardBorder="card-border"
                                        loadingAnimation={loadingQualitas}
                                        showError={showErrorQualitas}
                                        showErrorMessage={showErrorMessageQualitas}
                                        formikValues={values}
                                        vehicles={insuranceQualitas}
                                        showPrice={showCostoQualitas}
                                        movementId={movementIdQualitas}
                                        coverages={coveragesQualitas}
                                        handleChange={handleChange}
                                        quoteNumber={quoteNumberQualitas}
                                        receiptInfo={receiptInfo_cost_qualitas}
                                        userPermissions={props.userPermissions}
                                        disabled={false}/> : null}

                                {insuranceCompanies.find(company => company.id === 6) ?
                                    <InsuranceCard
                                        companyName="afirme"
                                        companyFormik={values.afirme}
                                        companyID='2'
                                        cardSize="col-sm-12 col-md-12 col-lg-10"
                                        cardImg={imgAfirme}
                                        imageStyles="mx-4 mt-4"
                                        cardBorder="card-border"
                                        loadingAnimation={loadingAfirme}
                                        showError={showErrorAfirme}
                                        showErrorMessage={showErrorMessageAfirme}
                                        formikValues={values}
                                        vehicles={insuranceAfirme}
                                        showPrice={showCostoAfirme}
                                        movementId={movementIdAfirme}
                                        coverages={coveragesAfirme}
                                        handleChange={handleChange}
                                        quoteNumber={quoteNumberAfirme}
                                        receiptInfo={receiptInfo_cost_afirme}
                                        userPermissions={props.userPermissions}
                                        disabled={false}/> : null}

                                {insuranceCompanies.find(company => company.id === 5) ?
                                    <InsuranceCard
                                        companyName="mapfre"
                                        companyFormik={values.mapfre}
                                        companyID='3'
                                        cardSize="col-sm-12 col-md-12 col-lg-10"
                                        imageStyles="mx-4 mt-4"
                                        cardImg={imgMapfre}
                                        cardBorder="card-border"
                                        loadingAnimation={loadingMapfre}
                                        showError={showErrorMapfre}
                                        showErrorMessage={showErrorMessageMapfre}
                                        formikValues={values}
                                        vehicles={insuranceMapfre}
                                        showPrice={showCostoMapfre}
                                        movementId={movementIdMapfre}
                                        coverages={coveragesMapfre}
                                        handleChange={handleChange}
                                        quoteNumber={quoteNumberMapfre}
                                        receiptInfo={receiptInfo_cost_mapfre}
                                        userPermissions={props.userPermissions}
                                        disabled={false}/> : null}

                                {insuranceCompanies.find(company => company.id === 7) ?
                                    <InsuranceCard
                                        companyName="gnp"
                                        companyFormik={values.gnp}
                                        companyID='7'
                                        cardSize="col-sm-12 col-md-12 col-lg-10"
                                        imageStyles="mx-4 mt-2"
                                        cardBorder="card-border"
                                        cardImg={imgGnp}
                                        loadingAnimation={loadingGnp}
                                        showError={showErrorGnp}
                                        showErrorMessage={showErrorMessageGnp}
                                        formikValues={values}
                                        vehicles={insuranceGnp}
                                        showPrice={showCostoGnp}
                                        movementId={movementIdGnp}
                                        coverages={coveragesGnp}
                                        handleChange={handleChange}
                                        quoteNumber={quoteNumberGnp}
                                        receiptInfo={receiptInfo_cost_gnp}
                                        userPermissions={props.userPermissions}
                                        disabled={false}/> : null}

                                {insuranceCompanies.find(company => company.id === 2) ?
                                    <InsuranceCard
                                        companyName="chubb"
                                        companyFormik={values.chubb}
                                        companyID='4'
                                        cardSize="col-sm-12 col-md-12 col-lg-10"
                                        cardBorder="card-border"
                                        imageStyles="mx-4 mt-4"
                                        cardImg={imgChubb}
                                        loadingAnimation={loadingChubb}
                                        showError={showErrorChubb}
                                        showErrorMessage={showErrorMessageChubb}
                                        formikValues={values}
                                        vehicles={insuranceChubb}
                                        showPrice={showCostoChubb}
                                        movementId={movementIdChubb}
                                        coverages={coveragesChubb}
                                        handleChange={handleChange}
                                        quoteNumber={quoteNumberChubb}
                                        receiptInfo={receiptInfo_cost_chubb}
                                        userPermissions={props.userPermissions}
                                        disabled={false}/> : null}

                                {insuranceCompanies.find(company => company.id === 8) ?
                                    <InsuranceCard
                                        companyName = "Hdi Seguros"
                                        companyFormik={values.hdi}
                                        companyID='5'
                                        cardSize="col-sm-12 col-md-12 col-lg-10"
                                        cardBorder="card-border"
                                        imageStyles="img-hdi"
                                        cardImg={imgHdi}
                                        loadingAnimation={loadingHdi}
                                        showError={showErrorHdi}
                                        showErrorMessage={showErrorMessageHdi}
                                        formikValues={values}
                                        vehicles={insuranceHdi}
                                        showPrice={showCostoHdi}
                                        movementId={movementIdHdi}
                                        coverages={coveragesHdi}
                                        handleChange={handleChange}
                                        quoteNumber={quoteNumberHdi}
                                        receiptInfo={receiptInfo_cost_Hdi}
                                        userPermissions={props.userPermissions}
                                        disabled={false}
                                    />
                                    : null}


                                {/*hidden={props.userPermissions[4] !== 1 || isAbleToQuote === false*/}

                                <div className="col-5 float-end m-4" hidden={isAbleToQuote === false}>
                                    <button type="submit" className="btn btn-submit">
                                        Cotizar
                                    </button>
                                </div>

                            </div>

                        </Form>
                    )}
                </Formik>
            </div>
        </>
    )
}